module.exports = __webpack_public_path__ + "static/media/sock-anim-no-zoom-gif.f4a8613e.gif";